import '../styles/Nav.css';
// import home from '../assets/home.png'
import release from '../assets/release.png'
import item from '../assets/oot-icon.svg'
import game from '../assets/nintendo-switch.svg'
import character from '../assets/character.png'
import sword from '../assets/sword.png'
import library from '../assets/library.png'

import React, { useState } from 'react';

import ModalRelease from './ModalRelease.js';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';


function Nav() {
    const { t } = useTranslation();

    const [showModal, setShowModal] = useState(false);

    const toggleModal = () => {
        setShowModal(!showModal);
    };


	return (
            <div className="nav">
                { /* <div className='nav-item'><Link className='nav-item-link' to="/"><img src={home} alt="'release" title='Home'/></Link></div> */ }
                <div className='nav-item'>
                    <div className='nav-item-link'><Link to="/item"><img className='nav-item-link-img' src={item} alt="'release" title='Item mode' /></Link></div>
                    <div className='nav-item-link-text'>{t('nav.item')}</div>
                </div>
                <div className='nav-item'>
                    <div className='nav-item-link'><Link to="/game"><img className='nav-item-link-img' src={game} alt="'release" title='Game mode' /></Link></div>
                    <div className='nav-item-link-text'>{t('nav.game')}</div>
                </div>
                <div className='nav-item'>
                    <div className='nav-item-link'><Link to="/character"><img className='nav-item-link-img' src={character} alt="'release" title='Character mode' /></Link></div>
                    <div className='nav-item-link-text'>{t('nav.character')}</div>
                </div>
                <div className='nav-item'>
                    <div className='nav-item-link'><Link to="/sword"><img className='nav-item-link-img' src={sword} alt="'release" title='Sword mode' /></Link></div>
                    <div className='nav-item-link-text'>{t('nav.sword')}</div>
                </div>
                <div className='nav-item'>
                    <div className='nav-item-link'><Link to="/library"><img className='nav-item-link-img' src={library} alt="'release" title='Library' /></Link></div>
                    <div className='nav-item-link-text'>{t('nav.library')}</div>
                </div>
                <div className='nav-item'>
                    <div className='nav-item-link'><Link to="#"><img className='nav-item-link-img' src={release} alt="'release" onClick={toggleModal} title='Release Notes' /></Link></div>
                    <div className='nav-item-link-text'>{t('nav.release')}</div>
                </div>
                { showModal ? <ModalRelease showModal={showModal} setShowModal={setShowModal} onClose={toggleModal} /> : null }
            </div>

            
	)
}

export default Nav
